export interface PowerBiFilter {
  $schema: string
  filterType: number
  target: {
    column: string
    table: string
  }
  displaySettings?: {
    isHiddenInViewMode: boolean
  }
}

export const powerBiConfigDefaults = {
  type: 'report',
  tokenType: 1,
  settings: {
    filterPaneEnabled: false,
    navContentPaneEnabled: false,
  },
}

export const reportsFilters = {
  target: {
    column: 'Pool Name',
    table: 'Profit Center',
  },
}

export const powerBiPoolFilterDefaults = {
  $schema: 'http://powerbi.com/product/schema#basic',
  filterType: 1,
}
